import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid var(--line-gray);
  padding: 16px 10px;
  font-size: 12px;
  color: var(--text-secondary);
`;

const SidebarSelectorDropdownListEmptyState = () => <Container>No matches found</Container>;

export default SidebarSelectorDropdownListEmptyState;
